<script setup lang="ts">
import type { RankEntry, ReviewCompany } from "@/types/Ranking";
import houseReviewsData from "@/assets/data/house-reviews.json";
import mansionReviewsData from "@/assets/data/mansion-reviews.json";

const config = useRuntimeConfig();

// パンくず（OrganismsBreadcrumbs が metaTitle state を参照）
const metaTitle = useState("metaTitle");
metaTitle.value = "火災保険ランキング 2026年版";

useSeoMeta({
  title: "火災保険ランキング【2026年】",
  description:
    "戸建て・マンション別に、820人のアンケート調査をもとにした火災保険ランキングをご紹介。保険会社ごとの口コミ・評判も掲載しているので、火災保険の比較・検討に活用ください。",
  keywords: "火災保険,ランキング,口コミ,評判,比較,戸建て,マンション",
  ogTitle: "火災保険ランキング【2026年】｜保険スクエアbang! 火災保険",
  ogDescription:
    "戸建て・マンション別に、820人のアンケート調査をもとにした火災保険ランキングをご紹介。保険会社ごとの口コミ・評判も掲載しているので、火災保険の比較・検討に活用ください。",
  ogUrl: `${config.public.fireBangDomainName}/ranking/`,
});

// ===== ランキングデータ（ハイブリッド: 繰り返しは配列 + v-for）=====
const houseRanks: RankEntry[] = [
  { rank: 1, name: "東京海上日動火災保険" },
  { rank: 2, name: "あいおいニッセイ同和損害保険" },
  { rank: 3, name: "損保ジャパン" },
  { rank: 4, name: "三井住友海上火災保険" },
  { rank: 5, name: "ソニー損害保険" },
];

const mansionRanks: RankEntry[] = [
  { rank: 1, name: "東京海上日動火災保険" },
  { rank: 2, name: "三井住友海上火災保険" },
  { rank: 2, name: "損保ジャパン" },
  { rank: 4, name: "あいおいニッセイ同和損害保険" },
  { rank: 5, name: "ソニー損害保険" },
];

const houseReviews = houseReviewsData as ReviewCompany[];
const mansionReviews = mansionReviewsData as ReviewCompany[];
</script>

<template>
  <div>
    <OrganismsBreadcrumbs />
    <div class="wrap-contents">
      <div class="main-contents">
        <OrganismsRankingHero />

        <OrganismsRankingList
          :house-ranks="houseRanks"
          :mansion-ranks="mansionRanks"
        />

        <OrganismsRankingReviews type="house" :companies="houseReviews" />
        <OrganismsRankingRequest />

        <OrganismsRankingReviews type="mansion" :companies="mansionReviews" />
        <OrganismsRankingRequest />

        <OrganismsRankingHowToChoose />

        <OrganismsRankingUsageFlow>
          <template #cta>
            <OrganismsRankingRequest />
          </template>
        </OrganismsRankingUsageFlow>
      </div>
      <OrganismsSideContents :sideCateDisplay="false" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.breadcrumbs {
  padding: 0.8em 4% 1em;
}

.wrap-contents {
  padding: 0 0 30%;
  position: relative;
}

.main-contents {
  display: flex;
  flex-direction: column;
}

@include media(pc) {
  .breadcrumbs {
    padding: 11px 0 34px;
  }

  .wrap-contents {
    margin: 0 auto;
    padding: 6px 0 150px;
    width: $pcWrapWidth;
    display: flex;
    justify-content: space-between;
  }

  .main-contents {
    padding: 0;
    width: $pcMainContentsWidth;
  }


}
</style>
